import Component from './component';

export interface Props {
	currentSlide?: string | number;
	slideCount?: string | number;
	children: any;
}

export default Component;
